export function parseTwoKTime(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  const text = String(value).trim();
  if (!text) return null;
  if (text.includes(':')) {
    const parts = text.split(':');
    if (parts.length !== 2) return null;
    const minutes = parseInt(parts[0], 10);
    const seconds = parseFloat(parts[1]);
    if (!Number.isFinite(minutes) || !Number.isFinite(seconds)) return null;
    return minutes * 60 + seconds;
  }
  const n = parseFloat(text);
  return Number.isFinite(n) ? n : null;
}

export function formatTwoKTime(totalSeconds) {
  if (totalSeconds == null || totalSeconds === '') return '';
  const n = Number(totalSeconds);
  if (!Number.isFinite(n) || n <= 0) return '';
  const minutes = Math.floor(n / 60);
  const seconds = (n % 60).toFixed(1);
  return `${minutes}:${seconds.padStart(4, '0')}`;
}
